import React from "react";
import { AlertTriangle, Info, X } from "lucide-react";
import "./ConfirmModal.css";

const ConfirmModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Confirmer l'action", 
  message, 
  confirmText = "Confirmer", 
  cancelText = "Annuler",
  type = "warning" // warning, danger, info
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleBackdropClick}>
      <div className="modal-content confirm-modal">
        <div className="modal-header">
          <h2 className={`modal-title modal-title-${type} icon-inline`}>
            {type === "danger" && <AlertTriangle size={19} strokeWidth={2.25} />}
            {type === "warning" && <AlertTriangle size={19} strokeWidth={2.25} />}
            {type === "info" && <Info size={19} strokeWidth={2.25} />}
            {title}
          </h2>
          <button
            className="modal-close"
            onClick={onClose}
            aria-label="Fermer"
          >
            <X size={20} strokeWidth={2.25} />
          </button>
        </div>
        
        <div className="modal-body">
          <p>{message}</p>
        </div>
        
        <div className="modal-footer">
          <button 
            className="btn btn-outline" 
            onClick={onClose}
          >
            {cancelText}
          </button>
          <button 
            className={`btn ${type === "danger" ? "btn-error" : type === "warning" ? "btn-warning" : "btn-primary"}`}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;

